var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99964 0.867188C3.01922 0.867188 2.22444 1.66197 2.22444 2.64239V6.19278C2.22444 7.1732 3.01922 7.96798 3.99964 7.96798C4.98005 7.96798 5.77483 7.17319 5.77483 6.19278V2.64238C5.77483 1.66197 4.98005 0.867188 3.99964 0.867188ZM0.959081 6.66498C1.18604 8.14049 2.46116 9.27037 4.00017 9.27037C5.53919 9.27037 6.81431 8.14049 7.04127 6.66498C7.08101 6.40658 7.28912 6.19336 7.55057 6.19336C7.81201 6.19336 8.02688 6.40625 7.9965 6.66593C7.78536 8.47074 6.37984 9.91062 4.5915 10.174V10.3359C4.5915 10.6627 4.32657 10.9276 3.99976 10.9276C3.67296 10.9276 3.40803 10.6627 3.40803 10.3359V10.1739C1.62008 9.91018 0.214954 8.47047 0.00384782 6.66593C-0.0265302 6.40625 0.188334 6.19336 0.449777 6.19336C0.711221 6.19336 0.919334 6.40658 0.959081 6.66498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.f4d875d07370435f9ef8c9dee931dc2d.svg";
export { ForwardRef as ReactComponent };